<script>
import axios from 'axios';
export default {
  props: ['ticketActions', 'ticketCauses', 'users', 'ticket', 'event', 'device'],
  created() {
  },
  computed: {
  },
  data() {
    return {
      deviceData: null,
      ticketData: {
        actions: null,
        causes: null,
        minutes: null,
        currentTemp: null,
        currentWeather: null,
        coupure: false,
        technicien: null,
        note: null
      },
      err: {
        actions: null,
        causes: null,
        minutes: null,
      },

      ticketDataView: {},
      viewState: false,

      actionsList: [{ value: null, text: this.$t("titles.actions.text"), disabled: true }],
      causesList: [{ value: null, text: this.$t("titles.causes.text"), disabled: true }],
      usersList: [{ value: null, text: this.$t("titles.techniciens.text"), disabled: true }],
    };
  },
  watch: {
    ticketActions(newVal) {
      let actionsData = newVal;
      actionsData.map((obj) => {
          this.actionsList.push({ value: obj.id, text: obj.name });
      });
    },
    ticketCauses(newVal) {
      let causesData = newVal;
      causesData.map((obj) => {
          this.causesList.push({ value: obj.id, text: obj.name });
      });
    },
    event(newVal) {
      this.ticketData.currentTemp = newVal?.temp?.toFixed(2)
    },
    device(newVal) {
      const deviceTypes = {
        1: "REFRIGERATEUR",
        2: "CONGELATEUR",
        3: "ARMOIRES_FRIGORIFIQUE",
        4: "CHAMBRE_FROIDE",
        5: "CAMION",
        6: "SUPER_CONGELATEUR",
      }
      let type = null
      if(newVal.type) type = deviceTypes[newVal.type]
      this.deviceData = {
        ...newVal, 
        type
      }
    },
    ticket(newVal){
      if(newVal){   
        const seconds = (new Date(newVal.estimArrivAt).getTime() - new Date().getTime()) / 1000
        const restMinutes = `${parseInt(seconds / 60) > 0 ? parseInt(seconds / 60): 0} min, ${parseInt(seconds % 60) > 0 ? parseInt(seconds % 60) : 0} sec`
        if(newVal.status == 'CLOSED'){
          this.viewState = false
        }
        else if(seconds > 0 || newVal.status == 'OPENED'){
          this.ticketData.actions = newVal.actions
          this.ticketData.causes = newVal.causes.length > 0 ? newVal.causes : null
          this.ticketData.technicien = newVal.technicien ? newVal.technicien : null
          this.ticketData.note = newVal.note ? newVal.note : null
          this.ticketData.minutes = newVal.minutesToFinish
          this.ticketData.coupure = newVal.coupure
          this.ticketDataView = {
            ...newVal,
            minutesToFinish: newVal.estimArrivMinutes - (seconds / 60).toFixed(2),
            minutesToFinishString: restMinutes
          };
          this.viewState = true
        }
        
      }
      
    },
    users(newVal){
      let usersData = newVal;
      usersData.map((obj) => {
          this.usersList.push({ value: obj.id, text: obj.fullName });
      });
    }
  },
  methods: {
    handleModalShown(){
      if(!this.ticketData.currentWeather){
        const params = {
          latitude: [this.deviceData.lat],
          longitude: [this.deviceData.lng],
          current: 'temperature_2m,weather_code',
        };
        const url = 'https://api.open-meteo.com/v1/forecast';
        axios.get(url, {params}).then(res=>{
          const currentWeather = res.data.current?.temperature_2m
          this.ticketData.currentWeather = currentWeather?.toFixed(2)
        });
      } 
    },
    cancel() {
      //this.clear();
    },
    clear() {
      this.ticketData = {
        ...this.ticketData,
        actions: null,
        causes: null,
        minutes: null,
        coupure: false,
        technicien: null,
        note: null
      };
      this.err = {
        actions: null,
        causes: null,
        minutes: null,
      };
    },
    cloture(ok) {
      
      if (!this.ticketData.actions) this.err.actions = this.$t("msgError.obligField.text");
      else this.err.actions = "";

      if (!this.ticketData.causes) this.err.causes = this.$t("msgError.obligField.text");
      else this.err.causes = "";

      if (!this.err.actions && !this.err.causes) {
        const dataToSave = {
          ticketId: this.ticketDataView.id,
          actions: this.ticketData.actions,
          causes: this.ticketData.causes,
          coupure: this.ticketData.coupure,
          technicien: this.ticketData.technicien,
          note: this.ticketData.note,
          status: 'CLOSED'
        }
        ok();
        this.clear()
        this.$emit("clotureTicket", dataToSave);
      }
    },
    add(ok) {
      
      if (!this.ticketData.actions) this.err.actions = this.$t("msgError.obligField.text");
      else this.err.actions = "";

      if (!this.ticketData.minutes) this.err.minutes = this.$t("msgError.obligField.text");
      else this.err.minutes = "";

      if (!this.err.actions && !this.err.minutes) {
        const dateNow = new Date()
        dateNow.setMinutes(dateNow.getMinutes() + parseInt(this.ticketData.minutes));
        const dateArriv = dateNow.toISOString()
        const dataToSave = {
          ref: this.deviceData.ref,
          serial: this.deviceData.serial,
          region: this.deviceData.region.id,
          province: this.deviceData.province.id,
          centre: this.deviceData.centre?.id,
          actions: this.ticketData.actions,
          temp: parseFloat(this.ticketData.currentTemp),
          meteo: parseFloat(this.ticketData.currentWeather),
          estimArrivMinutes: parseInt(this.ticketData.minutes),
          estimArrivAt: dateArriv,
          coupure: this.ticketData.coupure,
          technicien: this.ticketData.technicien,
          note: this.ticketData.note,
          status: 'OPENED'
        }
        
        ok();
        this.$emit("saveTicket", dataToSave);
      }
    },
  },
};
</script>

<template>
  <div>
    <b-modal
      id="ticket-modal"
      ref="ticket-modal"
      size="lg"
      @hidden="cancel"
      :title="$t('modals.ticket.text')"
      @shown="handleModalShown"
    >

      <div class="row">
        <div class="col-12 text-center font-weight-bold" style="color: black">
          <p >{{deviceData?.name}}</p>
          <p >{{`${new Date().toLocaleDateString()} ${new Date().toLocaleTimeString()}`}}</p>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-lg-6" style="color: black">
          <div class="row">
            <div class="col-2 font-weight-bold">
              Serial:
            </div>
            <div class="col-10 text-secondary">
              {{deviceData?.serial}}
            </div>
          </div>
          <div class="row">
            <div class="col-2 font-weight-bold">
              Type:
            </div>
            <div class="col-10 text-secondary">
              {{deviceData?.type || '-'}}
            </div>
          </div>
        </div>
        <div class="col-12 col-lg-6" style="display: flex; flex-direction: row; justify-content: end">
          <div class="text-truncate" style="font-size: 0.8rem; color:black">
            <b>{{$t("modals.lastTemp.text")}} : </b> <span style="color: purple">{{ ticketData.currentTemp }} °C<br /></span>
          </div>
          <div class="text-truncate" style="font-size: 0.8rem; margin-left: 3%; color:black">
            <b>Méteo :</b> <span style="color: purple">{{ ticketData.currentWeather }} °C</span>
          </div>
        </div>
        <div class="col-12 col-lg-12" data-app>
          <v-select
            id="action"
            v-model="ticketData.actions"
            :items="actionsList"
            :menu-props="{ maxHeight: '200' }"
            item-text="text"
            item-value="value"
            multiple
          ></v-select>
          <b-form-invalid-feedback>
            {{ err.actions }}
          </b-form-invalid-feedback>

          <v-select
            id="technicien"
            v-model="ticketData.technicien"
            :items="usersList"
            :menu-props="{ maxHeight: '200' }"
            item-text="text"
            item-value="value"
          ></v-select>

          <v-select
            v-if="viewState"
            id="cause"
            v-model="ticketData.causes"
            :items="causesList"
            :menu-props="{ maxHeight: '200' }"
            item-text="text"
            item-value="value"
            multiple
          ></v-select>
          <b-form-invalid-feedback>
            {{ err.causes }}
          </b-form-invalid-feedback>

           <label for="note" style="color: black; font-size: 0.8rem">{{$t("modals.note.text")}}</label>
          <b-input
            id="note"
            v-model="ticketData.note"
            class="mb-1"
            :state="err.note ? false : null"
          ></b-input>

          <label v-if="!viewState" for="minutes" style="color: black; font-size: 0.8rem">{{$t("modals.minutes.text")}}</label>
          <b-input
            v-if="!viewState"
            id="minutes"
            v-model="ticketData.minutes"
            class="mb-1"
            type="number"
            :state="err.minutes ? false : null"
          ></b-input>
          <b-form-invalid-feedback v-if="!viewState">
            {{ err.minutes }}
          </b-form-invalid-feedback>

          
          <div style="font-size: 0.8rem; margin-top: 20px; color: black">
            <b-form-checkbox
              id="Coupure"
              v-model="ticketData.coupure"
              name="Coupure"
              :value="true"
              :unchecked-value="false"
            >
              Coupure d'électricité
            </b-form-checkbox>
          </div>
          <label v-if="viewState" for="timeEstim" style="font-size: 0.8rem; color: black; margin-top: 20px">{{$t("modals.timeLeft.text")}} : {{ticketDataView.minutesToFinishString}}</label>
          <b-progress v-if="viewState" :value="ticketDataView.minutesToFinish" :max="ticketDataView.estimArrivMinutes" height="1rem"></b-progress>
        </div>
      </div>

      <template #modal-footer="{ ok, cancel }">
        <div class="row p-2" v-if="!viewState">
          <div class="col-10 text-right p-1">
            <b-button variant="success" class="text-white" @click="add(ok)">
              {{$t("buttons.add.text")}}
            </b-button>
          </div>
          <div class="col-2 text-center p-1">
            <b-button @click="cancel()"> {{$t("buttons.cancel.text")}} </b-button>
          </div>
        </div>
        <div class="row p-2" v-if="viewState">
          <div class="col-10 text-right p-1">
            <b-button variant="success" class="text-white" @click="cloture(ok)">
              {{$t("buttons.cloture.text")}}
            </b-button>
          </div>
          <div class="col-2 text-center p-1">
            <b-button @click="cancel()"> {{$t("buttons.cancel.text")}} </b-button>
          </div>
        </div>
      </template>
    </b-modal>
  </div>
</template>